import { objectFromEntries } from '~/web-frontend-core/base/lib';
import { ALL_CATEGORY_ID } from '../../../outcomes.mobile/additional/categories/All.mobile';
import { AllMultiSelectCategories } from './AllMultiSelect';
import { COLUMN_WIDTH } from '~/web-frontend-core/api/const/base';
const FAVORITE_CATEGORY_ID = 'FAVOURITES';
export default class FavoriteCategories extends AllMultiSelectCategories {
    constructor(width = COLUMN_WIDTH.MEDIUM, onTablesSelect, onTablesFavorite, getFavoriteTables) {
        super(width, onTablesSelect);
        this.onTablesFavorite = onTablesFavorite;
        this.getFavoriteTables = getFavoriteTables;
        /** Категории, добавленные пользователем в избранное, общие среди матчей */
        this.favoriteCategories = new Map();
    }
    /**
     * Добавить категорию в избранное
     * @param matchID
     * @param categoryIDs
     * @param isFavorite
     */
    favorite(matchID, categoryIDs = [], isFavorite = true) {
        if (!this.getData(matchID)) {
            return;
        }
        if (categoryIDs.indexOf(FAVORITE_CATEGORY_ID) !== -1) {
            this.clearFavorite(matchID);
            return;
        }
        this.addFavoriteCategories(matchID, categoryIDs, isFavorite);
        const states = objectFromEntries(categoryIDs.map((categoryID) => [categoryID, { isFavorite }]));
        const tables = this.getFavoriteTables(this.sportID[matchID], matchID);
        const noFavoriteTables = tables.length === 0;
        if (noFavoriteTables) {
            this.clearFavorite(matchID);
            return;
        }
        states[FAVORITE_CATEGORY_ID] = {
            // [this.width]: this.getFavoriteCoefCount(matchID),
            isDisabled: noFavoriteTables,
            isFavorite: !noFavoriteTables,
            tables,
        };
        this.assignStates(matchID, states);
        this.select(matchID);
    }
    select(matchID, categoryIDs = Array.from(
    // @ts-ignore
    this.selectedCategories.has(matchID) && this.selectedCategories.get(matchID).values() || []), isSelected = true) {
        if (!this.selectedCategories.has(matchID)) {
            return;
        }
        if (categoryIDs.indexOf(ALL_CATEGORY_ID) !== -1) {
            this.unselectCategories(matchID);
            return;
        }
        if (!isSelected) {
            this.unselectCategories(matchID, categoryIDs);
            return;
        }
        const favoriteTables = this.getFavoriteTables(this.sportID[matchID], matchID);
        if (categoryIDs.indexOf(FAVORITE_CATEGORY_ID) !== -1 && favoriteTables.length !== 0) {
            this.unselectCategories(matchID);
            const newStates = {
                [ALL_CATEGORY_ID]: { isSelected: false },
                [FAVORITE_CATEGORY_ID]: { isSelected: true, tables: favoriteTables },
            };
            this.assignStates(matchID, newStates);
            this.selectedCategories.set(matchID, new Set([FAVORITE_CATEGORY_ID]));
            this.selectTables(matchID);
            return;
        }
        this.selectCategories(matchID, categoryIDs);
    }
    selectCategories(matchID, categoryIDs) {
        const selectedCategories = this.selectedCategories.get(matchID);
        if (!selectedCategories) {
            return;
        }
        categoryIDs.forEach((categoryID) => {
            selectedCategories.add(categoryID);
        });
        selectedCategories.delete(FAVORITE_CATEGORY_ID);
        this.selectTables(matchID);
        const states = objectFromEntries(Array.from(selectedCategories.values() || [])
            .map((categoryID) => [categoryID, { isSelected: true }]));
        const newStates = Object.assign({ [ALL_CATEGORY_ID]: { isSelected: selectedCategories.size === 0 }, [FAVORITE_CATEGORY_ID]: { isSelected: false } }, states);
        this.assignStates(matchID, newStates);
    }
    deleteCategories(matchID, categoryIDs) {
        const categories = categoryIDs.filter((c) => c !== FAVORITE_CATEGORY_ID);
        super.deleteCategories(matchID, categories);
        this.addFavoriteCategories(matchID, categories, false);
    }
    createNewCategories(matchID, sportID, config, newStates, categoriesLabels, selected) {
        super.createNewCategories(matchID, sportID, config, newStates, categoriesLabels, selected);
        this.select(matchID, selected || void 0, true);
        if (!this.favoriteCategories.has(sportID)) {
            this.favoriteCategories.set(sportID, new Set());
        }
        const favoriteCategories = this.favoriteCategories.get(sportID);
        this.favorite(matchID, Array.from(favoriteCategories && favoriteCategories.values() || []));
    }
    createNewCategoriesStates(matchID, sportID, config, newStates, selected) {
        const tables = this.getFavoriteTables(sportID, matchID);
        const states = super.createNewCategoriesStates(matchID, sportID, config, newStates, selected);
        states[FAVORITE_CATEGORY_ID] = FavoriteCategories.createFavoriteCategoryState(tables);
        return states;
    }
    setCategoriesLabels(matchID, categoriesLabels, prevStates) {
        categoriesLabels.forEach(({ id, txt }) => { prevStates[id].label = txt; });
        this.order.set(matchID, [ALL_CATEGORY_ID].concat(categoriesLabels.map(({ id }) => id), FAVORITE_CATEGORY_ID));
    }
    /**
     * Очистить все избранные категории
     */
    clearFavorite(matchID) {
        const favoriteCategories = this.favoriteCategories.get(this.sportID[matchID]);
        const states = objectFromEntries(Array.from(favoriteCategories.values())
            .map((categoryID) => [categoryID, { isFavorite: false }]));
        states[FAVORITE_CATEGORY_ID] = {
            // [this.width]: this.getFavoriteCoefCount(matchID),
            isDisabled: true,
            isFavorite: false,
            tables: [],
        };
        favoriteCategories.clear();
        this.addFavoriteTables(matchID, [ALL_CATEGORY_ID], false);
        this.assignStates(matchID, states);
        this.select(matchID);
    }
    addFavoriteCategories(matchID, categoryIDs, isFavorite) {
        if (categoryIDs.length === 0) {
            return;
        }
        const sportID = this.sportID[matchID];
        const favoriteCategories = this.favoriteCategories.get(sportID);
        const action = isFavorite ?
            (c) => { favoriteCategories.add(c); } :
            (c) => { favoriteCategories.delete(c); };
        categoryIDs.forEach(action);
        const states = objectFromEntries(categoryIDs.map((categoryID) => [categoryID, { isFavorite }]));
        this.assignStates(matchID, states);
        this.addFavoriteTables(matchID, categoryIDs, isFavorite);
    }
    /** Добавляет в избранное все таблицы избранных категорий */
    addFavoriteTables(matchID, categoryIDs, isFavorite) {
        const categories = this.getData(matchID);
        if (!categories) {
            return;
        }
        const favoriteTables = categoryIDs
            .filter((categoryID) => categoryID in categories)
            .map((categoryID) => { var _a; return ((_a = categories[categoryID]) === null || _a === void 0 ? void 0 : _a.tables) || []; })
            .reduce((allTables, tables) => allTables.concat(tables), []);
        if (favoriteTables.length === 0) {
            return;
        }
        this.onTablesFavorite(matchID, favoriteTables, isFavorite);
    }
    /** Возвращает общее число избранных коэф */
    // TODO поправить баг кол-во коэф. при добавление в избранное таблицы
    // private getFavoriteCoefCount(matchID: GameID): number {
    //    const categories = this.getData(matchID);
    //    if (!categories) {
    //       throw new Error('Попытка обратиться к несуществующей категории!');
    //    }
    //    return Array
    //       .from(this.favoriteCategories.values())
    //       .map((categoryID) => categories[categoryID][this.width])
    //       .filter((count): count is number => typeof count !== 'undefined')
    //       .reduce((acc, count) => acc + count, 0);
    // }
    static createFavoriteCategoryState(tables) {
        return { tables, isDisabled: tables.length === 0 };
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/line/outcomes/additional/categories/Favorite.js